import { requestGet, requestPost } from '@/common/request';

export default {
  async actRoomRoomHeader(query) {
    return await requestGet('/actRoom/roomHeader', query);
  },
  async actRoomFloorList(query) {
    return await requestGet('/actRoom/floorList', query);
  },
  async actRoomAddPage(query) {
    return await requestPost('/actRoom/addPage', query);
  },
  async cateList(query) {
    return await requestGet('/cate/list', query);
  },
  // 会场模块查询活动会场列表
  async actRoomList(query) {
    return await requestGet('/actRoom/list', query);
  },

  // 会场模块-关联会场
  async actRoomCorrelate(query) {
    return await requestPost('/actRoom/correlate', undefined, { body: query });
  },

  // 会场模块-取关会场
  async actRoomRelieve(query) {
    return await requestGet('/actRoom/relieve', query);
  },
  // 活动权限分享-是否是分享组成员
  async activityPlanGetShareInfo(query) {
    return await requestGet('/activityPlan/getShareInfo', query);
  },
  // 活动权限分享-添加分享组成员
  async activityPlanShare(query) {
    return await requestGet('/activityPlan/share', query);
  },
  // 活动权限分享-查询分享组成员
  async activityPlanListShare(query) {
    return await requestGet('/activityPlan/listShare', query);
  },
  // 活动权限分享-删除分享组成员
  async actRoomDeleteShare(query) {
    return await requestGet('/activityPlan/deleteShare ', query);
  },

  async activityPlanGet(query) {
    return await requestGet('/activityPlan/getByVer', query);
  },

  async materialPoolHeader(query) {
    return await requestGet('/materialPool/header', query);
  },

  async materialPoolUrge(query) {
    return await requestGet('/materialPool/urge', query);
  },
  // 获取部门、类目树
  async statisticTree(query) {
    return await requestGet('/statistic/tree', query);
  },
  async materialPoollistGroup(query) {
    return await requestGet('/materialPool/listGroup', query);
  },
  // 获取底池素材设置信息
  async potSettingInfo(query) {
    return await requestGet('/pot/settingInfo', query);
  },
  // 获取底池素材设置信息-830
  async materialPoolGetPool(query) {
    return await requestGet('/materialPool/getPool', query);
  },
  // 获取底池素材设置信息-830
  async materialPoolGetMaterials(query) {
    return await requestGet('/materialPool/getMaterials', query);
  },

  async materialPoollistMaterial(query) {
    return await requestGet('/materialPool/listMaterial', query);
  },
  async materialPoolcreateGroupByMaterial(query) {
    return await requestGet('/materialPool/createGroupByMaterial', query);
  },
  async materialPooladdMaterialToGroup(query) {
    return await requestGet('/materialPool/addMaterialToGroup', query);
  },
  async materialPoolofflineMaterial(query) {
    return await requestGet('/materialPool/offlineMaterial', query);
  },
  async materialPoollistTower(query) {
    return await requestGet('/materialPool/listTower', query);
  },
  // 保存素材底池设置
  async potSaveSetting(query) {
    return await requestPost('/pot/save/setting', query);
  },
  // 素材底池 - 创建品类BI素材组
  async materialPoolCreateBiMaterialGroup(query) {
    return await requestPost('/materialPool/createBiMaterialGroup', query);
  },
  // 素材底池 - 查询品类BI素材组
  async materialPoolQueryBiMaterialGroup(query) {
    return await requestGet('/materialPool/queryBiMaterialGroup', query);
  },
  // 素材底池 - 编辑品类BI素材组
  async materialPoolUpdateBiMaterialGroup(query) {
    return await requestPost('/materialPool/updateBiMaterialGroup', query);
  },
  // 素材底池 - 获取通天塔信息
  async materialPoolBabelInfo(query) {
    return await requestGet('/materialPool/babelInfo', query);
  },
  // // 素材底池 - 上传素材
  async materialPoolUpload(query) {
    return await requestPost('/materialPool/upload', query);
  },
  // 素材底池-获取素材
  async materialPoolGet(query) {
    return await requestGet('/materialPool/get', query);
  },
  // 不启用底池
  async materialPoolPoolDisable(query) {
    return await requestGet('/materialPool/poolDisable', query);
  },
  async roomPoolGetSlotList(query) {
    return await requestGet('/roomPool/getSlotList', query);
  },
};
